<template>
  <div class="content">

    <settings-menu></settings-menu>
    <div class="settings-body">
      <div class="settings-body-inner">

        <div v-if="settings" class="row">
          <div class="col-md-6">
            <div class="s-block">
              <div class="s-block-header">Logo & Branding</div>
              <div class="s-cover-photo">
                <div class="charity-img text-center">
                  <div v-if="isCoverPhotoUploading" class="avatar-loading">
                    <font-awesome-icon class="text-primary" spin :icon="['fas', 'spinner']"/>
                  </div>

                  <div v-else>
                    <img v-if="activeCharityInfo" :src="activeCharityInfo.cover_photo">
                    <input type="file" accept="image/*" @change="onCoverPhotoChanged">
                    <div class="inner-text">
                      <div><font-awesome-icon :icon="['fas', 'images']"/></div>
                      <p>Change Photo</p><span>Replace the cover photo</span>
                    </div>
                  </div>

                </div>
                <div class="logo-wrap text-center">
                  <div v-if="isLogoUploading" class="avatar-loading">
                    <font-awesome-icon class="text-primary" spin :icon="['fas', 'spinner']"/>
                  </div>
                  <div v-else>
                    <img v-if="activeCharityInfo" class="logo" :src="activeCharityInfo.logo_transparent" width="150"/>
                    <input type="file" accept="image/*" @change="onLogoChanged">
                    <div class="inner-text">
                      <div><font-awesome-icon :icon="['fas', 'images']"/></div>
                      <p>Change Logo</p>
                    </div>
                  </div>
                </div>
                <div v-if="activeCharityInfo"
                     class="logo-wrap favicon-wrap text-center" :class="{'not-added': !activeCharityInfo.logo_square}"
                     content="This is the square image that displays on the browser tab"
                     v-tippy="{ placement : 'top',  arrow: true}"
                >
                  <div v-if="isFaviconUploading" class="avatar-loading">
                    <font-awesome-icon class="text-primary" spin :icon="['fas', 'spinner']"/>
                  </div>
                  <div v-else>
                    <img v-if="activeCharityInfo && activeCharityInfo.logo_square" class="logo" :src="activeCharityInfo.logo_square"
                         width="150"/>
                    <input type="file" accept="image/*" @change="onFaviconChanged">
                    <div class="inner-text">
                      <div><font-awesome-icon :icon="['fas', 'images']"/></div>
                      <p>Favicon</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="s-block-body">
                <div class="row row-form">
                  <div class="col-md-12">
                    <div class="form-item">
                      <label for="organization-name">Organization Name</label>
                      <input type="text" class="form-control" id="organization-name" v-model="name"
                             placeholder="Organization Name">
                    </div>
                  </div>

                  <div v-if="primaryColor" class="col-md-6">
                    <div class="form-item">
                      <label :for="`primary-color`">Primary Color</label>
                      <color-preview :color="primaryColor" uniq-id="primary-color" v-model="primaryColor"/>
                    </div>
                  </div>
                  <div v-if="secondaryColor" class="col-md-6">
                    <div class="form-item">
                      <label :for="`secondary-color`">Secondary Color</label>
                      <color-preview :color="secondaryColor" uniq-id="secondary-color" v-model="secondaryColor"/>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-item">
                      <label for="organization-mission">Mission/Cause</label>
                      <textarea class="form-control"
                                rows="3"
                                id="organization-mission"
                                placeholder="Organization Mission"
                                v-model="description"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="s-block">
              <div class="s-block-header">Organization Information</div>
              <div class="s-block-body">
                <div class="row row-form">

                  <div class="col-md-6">
                    <div class="form-item">
                      <label for="organization-website">Website</label>
                      <input type="text"
                             class="form-control"
                             id="organization-website"
                             placeholder="Website"
                             v-model="website"
                      >
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-item">
                      <label for="facebook-pixel">Facebook Pixel</label>
                      <input type="text"
                             class="form-control"
                             id="facebook-pixel"
                             placeholder="Pixel ID"
                             v-model="facebookPixel"
                      >
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-item">
                      <label for="organization-ein">EIN</label>

                      <masked-input
                          type="text"
                          id="organization-ein"
                          inputmode="numeric"
                          class="form-control"
                          pattern="[0-9]{2}-[0-9]{7}"
                          v-model="ein"
                          :mask="[/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]"
                          :guide="true"
                          :placeholderChar="'\u2000'"
                          placeholder="EIN"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-item">
                      <label for="google-analytics">Google Analytics</label>
                      <input type="text"
                             class="form-control"
                             id="google-analytics"
                             placeholder="Google Analytics ID"
                             pattern="^ua-\d{4,9}-\d{1,4}"
                             v-model="googleAnalytics"
                      >
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-item">
                      <label for="organization-email">Email (Organization)</label>
                      <input type="text"
                             class="form-control"
                             id="organization-email"
                             placeholder="Email"
                             v-model="email"
                      >
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-item">
                      <label for="organization-phone" style="white-space: nowrap;">Phone Number (Organization)</label>
                      <input type="text"
                             class="form-control m-bottom"
                             id="organization-phone"
                             placeholder="Phone"
                             v-model="phone_number"
                      >
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-item">
                      <label for="organization-address">Address</label>
                      <input type="text"
                             class="form-control"
                             id="organization-address"
                             placeholder="Address"
                             v-model="address_line_1"
                      >
                    </div>

                    <div class="form-item">
                      <label for="organization-street">Room/Unit/Suite</label>
                      <input type="text"
                             class="form-control"
                             id="organization-street"
                             placeholder="Street"
                             v-model="address_line_2"
                      >
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-item">
                      <label for="organization-city">City</label>
                      <input type="text"
                             class="form-control"
                             id="organization-city"
                             placeholder="City"
                             v-model="address_city"
                      >
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-item">
                      <label for="organization-state">State</label>
                      <input type="text"
                             class="form-control"
                             id="organization-state"
                             placeholder="State"
                             v-model="address_state"
                      >
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-item">
                      <label for="zip-code">Zip Code</label>
                      <input type="text"
                             class="form-control m-bottom"
                             id="zip-code"
                             placeholder="Zip Code"
                             v-model="address_zip"
                      >
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-item">
                      <label>Social Profiles</label>
                      <div class="input-group">
                        <span class="input-group-addon input-group-twitter">
                          <font-awesome-icon :icon="['fab', 'twitter']"/>
                        </span>
                        <input type="text"
                               class="form-control"
                               placeholder="@twitterusername"
                               v-model="twitter"
                        >
                      </div>
                      <div class="input-group">
                        <span class="input-group-addon input-group-facebook">
                          <font-awesome-icon :icon="['fab', 'facebook-f']"/>
                        </span>
                        <input type="text"
                               class="form-control"
                               placeholder="https://facebook.com/username"
                               v-model="facebook"
                        >
                      </div>
                    </div>
                  </div>

                  <!--div class="col-lg-6">
                    <div class="form-item">
                      <label for="annual-fundraising">Annual Fundraising</label>
                      <input type="text" class="form-control" id="annual-fundraising" placeholder="$500,000+"
                             value="$500,000+">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-item">
                      <label for="organization-phone" style="white-space: nowrap;">Type/Category of Nonprofit</label>
                      <input type="text" class="form-control" id="type-of-nonprofit" placeholder="Select One">
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="form-item">
                      <label for="organization-c-status">501(c)(3) Status</label>
                      <input type="text" class="form-control" id="organization-c-status" placeholder=""
                             value="$500,000+">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-item">
                      <label for="organization-ein" style="white-space: nowrap;">EIN #</label>
                      <input type="text" class="form-control" id="organization-ein" placeholder="" value="$500,000+">
                    </div>
                  </div-->

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-if="isEdited" class="settings-btn-bottom">
        <div class="text-right btn-wrap">
          <a href="#" v-on:click.prevent="updateSettings" class="btn btn-sm btn-cancel">Cancel</a>
          <a href="#" v-on:click.prevent="saveSettings" class="btn btn-sm btn-sm-edit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getOrganizationSettings, putOrganizationSettings, globalImageUploader} from '@/utils/api';
  import MaskedInput from 'vue-text-mask';

  import SettingsMenu from './menu.vue';
  import ColorPreview from '../ColorPreview/index.vue';

  import {mapState} from "vuex";

  export default {
    name: 'Organization',
    metaInfo: {
      title: 'Settings - Organization',
    },
    mounted() {
      this.reloadSettings();
    },
    components: {
      SettingsMenu,
      ColorPreview,
      MaskedInput,
    },
    methods: {
      saveSettings() {
        putOrganizationSettings({
          'name': this.name,
          'website': this.website,
          'email': this.email,
          'ein': this.ein,
          'phone_number': this.phone_number,
          'description': this.description,
          'primary_color': this.primaryColor,
          'secondary_color': this.secondaryColor,
          'facebook': this.facebook,
          'twitter': this.twitter,
          'address': {
            'line_1': this.address_line_1,
            'line_2': this.address_line_2,
            'city': this.address_city,
            'state': this.address_state,
            'zip': this.address_zip,
          },
          'addons': {
            'facebook_pixel': this.facebookPixel ? this.facebookPixel : null,
            'google_analytics': this.googleAnalytics ? this.googleAnalytics : null,
          },
        }).then(() => {
          this.$message('Organization settings updated');
          this.reloadSettings();
        }).catch(err => alert(err.error || 'An error has occurred, please try again.'));
      },
      reloadSettings() {
        getOrganizationSettings().then(settings => {
          this.settings = settings;
          this.updateSettings();
        });
      },
      setOrganizationInfo(organizationInfo) {
        this.$store.commit('charities/SET_UPDATED_ORGANIZATION', organizationInfo)
      },
      updateSettings() {
        this.name = this.settings.name || '';
        this.primaryColor = this.settings.primary_color || '#ffffff';
        this.secondaryColor = this.settings.secondary_color || '#ffffff';
        this.description = this.settings.description || '';
        this.website = this.settings.website || '';
        this.facebookPixel = this.settings.addons.facebook_pixel || '';
        this.googleAnalytics = this.settings.addons.google_analytics || '';
        this.email = this.settings.email || '';
        this.ein = this.settings.ein || '';
        this.phone_number = this.settings.phone_number || '';
        this.facebook = this.settings.facebook || '';
        this.twitter = this.settings.twitter || '';
        this.address_city = this.settings.address.city || '';
        this.address_line_1 = this.settings.address.line_1 || '';
        this.address_line_2 = this.settings.address.line_2 || '';
        this.address_state = this.settings.address.state || '';
        this.address_zip = this.settings.address.zip || '';
      },
      onLogoChanged(e) {
        const file = e.target.files[0];
        if (file) {
          this.isLogoUploading = true;
          if (file.type.substr(0, 5) === 'image') {
            globalImageUploader(file).then((result) => {
              if (result) {
                putOrganizationSettings({logo: result}).then((result) => {
                  this.setOrganizationInfo(result);
                  this.isLogoUploading = false;
                });
              } else {
                this.isLogoUploading = false;
                alert('image post error');
              }
            }).catch(() => {
              this.isLogoUploading = false;
              alert('image post error');
            });
          }
        }
      },
      onFaviconChanged(e) {
        const file = e.target.files[0];
        this.isFaviconUploading = true;
        this.validateFavIconImage(file, false).then(() => {
          globalImageUploader(file).then((link) => {
            putOrganizationSettings({logo_square: link}).then((result) => {
              this.setOrganizationInfo(result);
              this.isFaviconUploading = false;
            }).catch(err => {
              this.isFaviconUploading = false;
              alert(err.error || 'Please upload an image with exactly Square dimensions e.g. 100px x 100px.');
            });
          }).catch(() => {
            this.isFaviconUploading = false;
            alert('Image saving error, please try again.');
          });
        }).catch(() => {
          this.isFaviconUploading = false;
          alert('Please upload an image with exactly Square dimensions e.g. 100px x 100px');
        })
      },
      validateFavIconImage(image, checkDimension = true) {
        return new Promise((resolve, reject) => {
          if (!image || image.type.substr(0, 5) !== 'image') {
            reject()
          }
          if(checkDimension) {
            let reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = evt => {
              let img = new Image();
              img.onload = () => {
                if(this.width !== this.hight){
                  reject()
                }
                resolve()
              }
              img.src = evt.target.result
            }
          } else {
            resolve()
          }
        })
      },
      onCoverPhotoChanged(e) {
        const file = e.target.files[0];
        if (file) {
          this.isCoverPhotoUploading = true;
          if (file.type.substr(0, 5) === 'image') {
            globalImageUploader(file).then((result) => {
              if (result) {
                putOrganizationSettings({cover_photo: result}).then((result) => {
                  this.setOrganizationInfo(result);
                  this.isCoverPhotoUploading = false;
                });
              } else {
                alert('image post error');
                this.isCoverPhotoUploading = false;
              }
            }).catch(() => {
              this.isCoverPhotoUploading = false;
              alert('image post error');
            });
          }
        }
      },
    },
    watch: {
      'activeCharityInfo'() {
        this.isLogoUploading = false;
        this.isCoverPhotoUploading = false;
        this.isFaviconUploading = false;
      },
      'activeCharityId'() {
        this.settings = null;
        this.reloadSettings();
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      isEdited() {
        if (this.settings) {

          if ((this.settings.name || '') !== this.name
            || (this.settings.primary_color || '') !== this.primaryColor
            || (this.settings.secondary_color || '') !== this.secondaryColor
            || (this.settings.description || '') !== this.description
            || (this.settings.website || '') !== this.website
            || (this.settings.addons.facebook_pixel || '') !== this.facebookPixel
            || (this.settings.addons.google_analytics || '') !== this.googleAnalytics
            || (this.settings.email || '') !== this.email
            || (this.settings.ein || '') !== this.ein
            || (this.settings.phone_number || '') !== this.phone_number
            || (this.settings.address.city || '') !== this.address_city
            || (this.settings.address.line_1 || '') !== this.address_line_1
            || (this.settings.address.line_2 || '') !== this.address_line_2
            || (this.settings.address.state || '') !== this.address_state
            || (this.settings.address.zip || '') !== this.address_zip
            || (this.settings.facebook || '') !== this.facebook
            || (this.settings.twitter || '') !== this.twitter
          ) {
            return true;
          }
          //check all properties
        }
        return false;
      },
    },

    data() {
      return {
        settings: null,

        isLogoUploading: false,
        isFaviconUploading: false,
        isCoverPhotoUploading: false,

        name: '',
        primaryColor: '',
        secondaryColor: '',
        description: '',
        website: '',
        facebookPixel: '',
        googleAnalytics: '',
        email: '',
        ein: '',
        phone_number: '',
        address_city: '',
        address_line_1: '',
        address_line_2: '',
        address_state: '',
        address_zip: '',
        facebook: '',
        twitter: '',

      };
    },

  };
</script>
<style lang="scss" scoped>
  .settings-body {
    .m-bottom {
      margin-bottom: 40px
    }

    .logo-wrap, .charity-img {
      input[type="file"] {
        z-index: 200;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0;
        cursor: pointer;
      }

      .inner-text {
        display: none;
        background-color: rgba(53, 64, 82, 0.7);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        color: #ffffff;
      }

      &:hover {
        .inner-text {
          display: block;
        }

        span {
          font-size: 10px;
          line-height: 1.4;
        }

        .fa-images {
          font-size: 28px;
          color: #ffffff;
          margin: 24px auto 5px;
        }

        p {
          font-size: 14px;
          margin-bottom: 0;
        }
      }
    }

    .logo-wrap {
      input[type="file"] {
        font-size: 5px;
      }

      .inner-text {
        border-radius: 4px;
      }

      &.favicon-wrap {
        left: 155px;
        width: 60px;
        height: 60px;

        .avatar-loading {
          line-height: 60px;
        }

        &:hover,
        &.not-added {
          .inner-text {
            display: block;
          }

          span {
            font-size: 8px;
          }

          .fa-images {
            font-size: 22px;
            margin: 5px auto;
          }

          p {
            font-size: 12px;
          }
        }
      }
    }

    .charity-img {
      input[type="file"] {
        font-size: 50px;
      }

      .inner-text {
        padding-top: 80px;
      }
    }
  }
</style>
